import { Node } from '@tiptap/core';

// Блочный «прокладочный» узел, занимающий вертикальное пространство,
// чтобы перенести следующий контент на новую страницу
const PageSpacerExtension = Node.create({
  name: 'pageSpacer',

  group: 'block',
  atom: true,
  // Делаем узел выделяемым, чтобы пользователь мог удалить ручной разрыв клавишей Delete/Backspace
  selectable: true,
  draggable: false,

  addAttributes() {
    return {
      height: {
        default: 0,
        parseHTML: element => {
          const h = element.getAttribute('data-height');
          return h ? parseInt(h, 10) || 0 : 0;
        },
        renderHTML: attributes => ({ 'data-height': String(attributes.height || 0) })
      },
      locked: {
        default: false,
        parseHTML: element => element.getAttribute('data-locked') === 'true',
        // Всегда выдаём признак, чтобы различать авто/ручные в CSS
        renderHTML: attributes => ({ 'data-locked': attributes.locked ? 'true' : 'false' })
      }
    };
  },

  parseHTML() {
    return [{ tag: 'div[data-type="page-spacer"]' }];
  },

  renderHTML({ HTMLAttributes, node }) {
    const height = node?.attrs?.height || 0;
    return ['div', {
      'data-type': 'page-spacer',
      ...HTMLAttributes,
      style: [
        'display:block',
        `height:${Math.max(0, height)}px`,
        'min-height:0',
        'margin:0',
        'padding:0',
        'background: transparent',
        'border: none',
        'user-select:auto',
        'pointer-events:auto',
      ].join(';')
    }];
  },
});

export default PageSpacerExtension;
